export const POST_PURCHASE_STATE = 'postPurchase';
export const MANAGEABLE_LOAN_STATE = 'manageableLoan';
export const PAID_OFF_LOAN_STATE = 'paidOffLoan';
export const TEST = 'test';

export const AppRoute = {
  MY_CARVANA: '/my-carvana',
  CARS: '/cars',
  SELL_MY_CAR: '/sell-my-car',
  RETURN_POLICY: '/help/purchasing-a-car/what-are-the-limits-of-the-7-day-money-back-guarantee',
};

export const Analytics = {
  TEAM_NAME: 'op',
  PROJECT_NAME: 'my-carvana',
  CURRENT_VERSION: '_v1',
};

export const PaymentMethodType = {
  SAVING: 'Savings',
  CHECKING: 'Checking',
};

export const PaymentEligibilityTypes = {
  PAY_CURRENT_DUE: 'PAY_CURRENT_DUE',
  ONE_TIME_PAYMENT: 'ONE_TIME_PAYMENT',
  AUTO_PAYMENT: 'AUTO_PAYMENT',
  ALL_PAYMENTS: 'ALL_PAYMENTS',
};

export const AmountDueType = {
  OTHER: 'other',
  MINIMUM: 'minimum',
};

export const ScheduledPaymentsType = {};

export const LoanStatusType = {
  OVERDUE: 'overdue',
  PAID_OFF: 'paidOff',
  NO_LOAN: 'noLoan',
};

export const NextPaymentType = {
  AUTO_PAY: 'autopay',
  ONE_TIME_PAYMENT: 'oneTimePayment',
  NONE: 'none',
};

export const OneTimePaymentType = {
  PAYMENT: 'Payment',
  AUTO_PAY: 'Autopay',
};

export const PurchaseState = {
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'inProgress',
  ORDER_PLACED: 'orderPlaced',
  SALE_COMPLETE: 'saleComplete',
  POST_SALE: 'postSale',
  RESERVED: 'reserved',
};

export const Api = {
  GET_LEFT_RAIL_CARDS_API_URI: '/core/mycars/api/v1/facade/garage',
  GET_OVP_DATA_API_URI: '/core/mycars/api/v1/facade/ownedvehicle/',
  GET_OVP_MFE_FEED_API_URI: '/core/mycars/api/v1/facade/feed',
  GET_PREORDER_DATA_API_URI: '/op/mycarvana/api/v1/experiment/preordervehicle/',
  POST_PRE_ORDER_CANCELLATION: '/merch/vehicledetails/api/v1/purchase/cancel',
  POST_PRE_PURCHASE_CANCELLATION: '/oec/purchase/api/v1/purchase/cancelpurchase',
};

export const ReferenceTypes = {
  APPRAISAL: 'appraisal',
  VEHICLE: 'vehicle',
};

export const REFERENCE_TYPE_FALLBACK_ORDER = [ReferenceTypes.VEHICLE, ReferenceTypes.APPRAISAL];

export const BooleanString = {
  TRUE: 'true',
  FALSE: 'false',
};

export const Buckets = {
  CONTROL: 'control',
  CONTROL_FIXED: 'control_fixed',
  TREATMENT: 'treatment',
  BUTTON: 'button',
  WITH_VALUE: 'with-value',
  WITH_GRAPHIC: 'with-graphic',
  NO_WARRANTIES: 'no-warranties',
  MY_CARS: 'my-cars',
  MY_GARAGE: 'my-garage',
  UNDEFINED: undefined,
};

export const Experiments = {
  ADD_VEHICLE: 'op-add-vehicle-test',
  AFTER_SALE_REPAIR: 'op-asr-ovp',
  UNAUTHENTICATED_STATE: 'op-unauthenticated-state',
  CORE_SERVICE_AND_REPAIRS: 'core-service-and-repairs',
  SEVEN_DAY_MONEY_BACK_GUARANTEE: 'taf-core-ovp-7dmbg',
  INF_ONF_DEDUCTIBLE: 'taf-core-sr-inrf-onrf-deductible',
  PAINTED_DOOR: 'inventory-ltw-sr_painted_door',
  COSMETIC_VEHICLE_CONCERN_DETAILS: 'inventory-ltw-cosmetic-vehicle-concern-details',
  NON_COSMETIC_VEHICLE_CONCERN_DETAILS: 'inventory-ltw-non-cosmetic-vehicle-concern-details',
  MY_CARS_RESKIN: 'inventory-ltw-my-cars-reskin',
  COSMETIC_EXTERIOR_LOCATION: 'inventory-ltw-cosmetic-exterior-location',
};

export const OvpFeedTypes = {
  RECALLS: 'Recalls',
  DIGITAL_GLOVEBOX: 'DigitalGlovebox',
  LOAN_PAID_OFF: 'LoanPaidOff',
  LOAN_N_PAYMENTS: 'LoansAndPayments',
  WARRANTY: 'Warranty',
  ACTIVE_TRADE: 'ActiveTrade',
  EXPIRED_TRADE: 'ExpiredTrade',
  GAP_COVERAGE: 'GapCoverage',
  TRADE_PROMO: 'TradePromo',
  CARVANA_CARE: 'CarvanaCare',
  SEVEN_DAY_GUARANTEE: 'SevenDayGuarantee',
  VEHICLE_UPDATES: 'VehicleUpdates',
  AFTER_SALE_REPAIR: 'AfterSaleRepair',
  REGISTRATION: 'RegistrationStatus',
  SERVICE_AND_REPAIR: 'ServiceAndRepair',
  VEHICLE_COVERAGE: 'VehicleCoverage',
};

export const DateMasks = {
  Default: 'mmmm d, yyyy',
  DayOnly: 'dS',
  MonthDayYearForwardSlash: 'mm/dd/yyyy',
  MonthDayYear: 'mmm dd, yyyy',
  MonthDay: 'mmm dd',
  FullMonthDay: 'mmmm d',
  MMDDYYwSlash: 'mm/dd/yy',
};

export const APPRAISED_STATE = 'appraised';

/* OVP Loan Summary Card constants */

export const CardType = {
  LOAN_PAID_OFF: 'LoanPaidOff',
  LOANS_AND_PAYMENTS: 'LoansAndPayments',
};

export const CarvanaCareCoverageUrl =
  'https://assets.fastly.carvana.io/protection-products/CarvanaCareBrochureFeb2024.pdf';

export const CarvanaCareTypes = {
  Essential: 'Essential',
  Plus: 'Plus',
  Premier: 'Premier',
  Subscription: 'Subscription',
};

export const GloveBox = {
  FileName: 'Purchase Contracts',
};

export const GloveBoxEventProps: any = {
  'Purchase Contracts': 'purchaseContract',
  'Proof Of Insurance': 'insuranceCard',
};

export const Months = {
  JAN: 'January',
  FEB: 'February',
  MAR: 'March',
  APR: 'April',
  MAY: 'May',
  JUN: 'June',
  JUL: 'July',
  AUG: 'August',
  SEP: 'September',
  OCT: 'October',
  NOV: 'November',
  DEC: 'December',
};

export const Days = {
  SUN: 'Sunday',
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
};

export const VerificationString = {
  SINGULAR: 'Verification to Complete',
  PLURAL: 'Verifications to Complete',
};

export const CancellationReason = {
  CUSTOMER_SELF_CANCELLED: 'CustomerSelfCancelled',
};

export const OneCarStatus = {
  PRE_ORDER: 'preOrder',
  PRE_PURCHASE: 'prePurchase',
  POST_PURCHASE: 'postPurchase',
  APPRAISAL: 'appraisal',
};

const REG_PREFIX = 'ovp - registration -';
const ASR_PREFIX = 'ovp - asr -';

export const RegistrationAnalytics = {
  VIEWED: `${REG_PREFIX} viewed`,
  DROPDOWN_EXPANDED: `${REG_PREFIX} expand document type`,
  DOCUMENT_SELECTED: `${REG_PREFIX} document type selected`,
  CLICKED_UPLOAD: `${REG_PREFIX} clicked upload file`,
  UPLOADED_FILE: `${REG_PREFIX} uploaded file`,
  REMOVED_FILE: `${REG_PREFIX} removed file`,
  CLICKED_RETRY: `${REG_PREFIX} clicked retry`,
};

export const AsrAnalytics = {
  VIEWED: `${ASR_PREFIX} viewed`,
  CLICKED_GET_STARTED: `${ASR_PREFIX} clicked get started`,
  VIEWED_FORM: `${ASR_PREFIX} viewed form`,
  CLICKED_RECONDITIONING: `${ASR_PREFIX} clicked reconditioning standards`,
  CLICKED_FIND_REPAIR_FACILITY: `${ASR_PREFIX} clicked find repair facility`,
  EXPANDED_ISSUE_TYPE: `${ASR_PREFIX} expanded issue type`,
  SELECTED_ISSUE_TYPE: `${ASR_PREFIX} selected issue type`,
  EXPANDED_ISSUE_LOCATION: `${ASR_PREFIX} expanded issue location`,
  SELECTED_ISSUE_LOCATION: `${ASR_PREFIX} selected issue location`,
  EXPANDED_ISSUE_CATEGORY: `${ASR_PREFIX} expanded issue category`,
  SELECTED_ISSUE_CATEGORY: `${ASR_PREFIX} selected issue category`,
  DETAIL_FIELD_INTERACTION: `${ASR_PREFIX} detail field interaction`,
  CLICKED_SUBMIT: `${ASR_PREFIX} clicked submit`,
  EXPANDED_REPORTED_CONCERNS: `${ASR_PREFIX} expanded reported concerns`,
  CLICKED_CONCERN: `${ASR_PREFIX} clicked concern`,
  VIEWED_REPORTED_CONCERN: `${ASR_PREFIX} viewed reported concern`,
  REPORTED_CONCERN_ERROR: `${ASR_PREFIX} reported concern error`,
  COS_CLICKED_BACK: `${ASR_PREFIX} cosmetic - clicked back`,
  COS_CLICKED_REPLACE: `${ASR_PREFIX} cosmetic - clicked replace`,
  COS_CLICKED_SUBMIT: `${ASR_PREFIX} cosmetic - clicked submit`,
  COS_VIEWED_DISCLAIMER: `${ASR_PREFIX} cosmetic - viewed disclaimer`,
  COS_VIEWED_LIMIT: `${ASR_PREFIX} cosmetic - viewed limit`,
  COS_VIEWED_SUCCESS: `${ASR_PREFIX} cosmetic - viewed success`,
  MECH_VIEWED_SUCCESS: `${ASR_PREFIX} mechanic - viewed success`,
  MECH_SUCCESS_CLICKED_REPAIRS: `${ASR_PREFIX} mechanic - clicked repairs link`,
  MECH_SUCCESS_CALL_SILVERROCK_DIAGNOSTIC: `${ASR_PREFIX} mechanic - called silverrock diagnostic`,
  MECH_SUCCESS_TEXT_SILVERROCK: `${ASR_PREFIX} mechanic - texted silverrock`,
  MECH_SUCCESS_CALL_SILVERROCK_QUESTIONS: `${ASR_PREFIX} mechanic - called silverrock questions`,
};

export const AnalyticEvents = {
  ovpErrorState: 'ovp_error_state',
  ovpCardExpand: 'ovp_card_expand',
  ovpCardClicked: 'ovp_card_clicked',
  ovpCardCollapse: 'ovp_card_collapse',
  ovpWarrantyLinkClicked: 'ovp_warranty_link_clicked',
  ovpGloveBoxDownload: 'ovp_glovebox_download',
  ovpVehicleImageClicked: 'ovp_vehicle_image_clicked',
  ovpSeeVehicleDetailsClicked: 'ovp_see_vehicle_details_clicked',
  viewedOvpCardImpression: 'viewed_ovp_card_impression',
  viewMyCarvana: 'view_my_carvana',
  viewedOwnedVehiclePage: 'view_owned_vehicle_page',
  appraisedGarageExpand: 'appraised_garage_expand',
  appraisedGarageCollapse: 'appraised_garage_collapse',
  garageErrorState: 'garage_error_state',
  garageSearchCarsClicked: 'garage_search_cars_clicked',
  garageVehicleCardClicked: 'garage_vehicle_card_clicked',
  garageVehicleCardImpression: 'garage_vehicle_card_impression',
  garageVehicleCardCancelOrderClicked: 'garage_vehicle_card_cancel_order_clicked',
  orderCancelled: 'order_cancelled',
  cancelOrderDismissed: 'cancel_order_dismissed',
  cancelOrderConfirmed: 'cancel_order_confirmed',
  continueAfterCancellationClicked: 'continue_after_cancellation_clicked',
  ovpWarrantiesRendered: 'ovp_warranties_rendered',

  // new events
  sarRendered: 'ovp - service and repair - rendered',
  sarViewed: 'ovp - service and repair - viewed',
  sarClickedGetStarted: 'ovp - service and repair - clicked get started',
  sarClickRoadsidePhoneNumber: 'ovp - service and repair - clicked roadside assistance phone number',
  sarExpandedSubmittedCosmeticCase: 'ovp - service and repair - expanded submitted cosmetic cases',
  sarCollapsedSubmittedCosmeticCases: 'ovp - service and repair - collapsed submitted cosmetic cases',
  sarSubmittedCasesClickedViewDetails: 'ovp - service and repair - submitted cases - clicked view details',
  sarSubmittedCasesViewedConcernDetails: 'ovp - service and repair - submitted cases - viewed concern details',
  sarSubmittedCasesDismissedConcernDetails: 'ovp - service and repair - submitted cases - dismissed concern details',
  sarDismissed: 'ovp - service and repair - dismissed',
  sarCategoryViewed: 'ovp - service and repair - category - viewed',
  sarCategorySelectCategory: 'ovp - service and repair - category - select category',
  sarCategoryClickedNext: 'ovp - service and repair - category - clicked next',
  sarSubCategoryViewed: 'ovp - service and repair - subcategory - viewed',
  sarSubCategorySelectSubCategory: 'ovp - service and repair - subcategory - select subcategory',
  sarSubCategoryClickedNext: 'ovp - service and repair - subcategory - clicked next',
  sarSubSubCategoryViewed: 'ovp - service and repair - subsubcategory - viewed',
  sarSubSubCategorySelectSubSubCategory: 'ovp - service and repair - subsubcategory - select subsubcategory',
  sarSubSubCategoryClickedNext: 'ovp - service and repair - subsubcategory - clicked next',
  sarLocationViewed: 'ovp - service and repair - location - viewed',
  sarLocationSelectLocation: 'ovp - service and repair - location - select location',
  sarLocationClickedNext: 'ovp - service and repair - location - clicked next',
  sarLocationSpinnerConfirmed: 'ovp - service and repair - location - spinner confirmed',
  sarLocationSpinnerConfirmClicked: 'ovp - service and repair - location - spinner confirm clicked',
  sarLocationSpinnerAdjustLocation: 'ovp - service and repair - location - spinner adjust location',
  sarLocationSpinnerRotated: 'ovp - service and repair - location - spinner rotated',
  sarLocationSpinnerPinPlaced: 'ovp - service and repair - location - spinner pin placed',
  sarLocationSpinnerPinFailed: 'ovp - service and repair - location - spinner pin failed',
  sarLocationSpinnerFallback: 'ovp - service and repair - location - spinner fallback',
  sarLocationOtherRecorded: 'ovp - service and repair - location - other recorded',
  // Backup of the full concern-location record (LLM eval + model description + Document
  // Manager doc ids + secure image URLs + marked-spot detail) so we retain it in Snowflake
  // via clickstream even if the save-concern-location DB write is lost. The secure URLs are
  // time-limited (doc ids are the durable handle), but included per product decision.
  sarLocationConcernRecord: 'ovp - service and repair - location - concern record',
  sarOdometerViewed: 'ovp - service and repair - odometer - viewed',
  sarOdometerFocused: 'ovp - service and repair - odometer - focused',
  sarOdometerClickedSubmit: 'ovp - service and repair - odometer - clicked submit',
  sarConfirmMileageViewed: 'ovp - service and repair - confirm mileage - viewed',
  sarConfirmMileageTooLow: 'ovp - service and repair - confirm mileage - input too low',
  sarConfirmMileageClickedEditMileage: 'ovp - service and repair - confirm mileage - clicked edit mileage',
  sarConfirmMileageClickedItsCorrect: 'ovp - service and repair - confirm mileage - clicked its correct',
  sarCoverageScreenViewed: 'ovp - service and repair - coverage screen - viewed',
  sarCoverageScreenViewedIssueSubmitted: 'ovp - service and repair - coverage screen - issue submitted',
  sarCoverageScreenViewedContactUs: 'ovp - service and repair - coverage screen - viewed contact us',
  sarCoverageScreenClickedSuggestedPartner: 'ovp - service and repair - coverage screen - clicked suggested partner',
  // NEW
  sarCoverageScreenClickedSuggestedPartnerAddress:
    'ovp - service and repair - coverage screen - clicked suggested partner address',
  sarCoverageScreenClickedSuggestedPartnerPhoneNumber:
    'ovp - service and repair - coverage screen - clicked suggested partner phone number',
  //
  sarCoverageScreenClickedBottomButton: 'ovp - service and repair - coverage screen - clicked bottom button',
  sarCosmeticViewed: 'ovp - service and repair - cosmetic - viewed',
  sarCosmeticClickedImageSquare: 'ovp - service and repair - cosmetic - clicked image square',
  sarCosmeticClickedUpload: 'ovp - service and repair - cosmetic - clicked upload',
  sarCosmeticClickReUpload: 'ovp - service and repair - cosmetic - clicked re-upload',
  sarCosmeticClickedSaveAndContinue: 'ovp - service and repair - cosmetic - clicked save & continue',
  sarCosmeticSubmissionSuccessful: 'ovp - service and repair - cosmetic - submission successful',
  sarCosmeticSubmissionFailed: 'ovp - service and repair - cosmetic - submission failed',
  sarExperiment: 'ovp - service and repair - experiment',
  sarClickedBackButton: 'ovp - service and repair - clicked back',

  // NEW SAR EVENTS Phase 2
  sarCoverageScreenClickedBenefits: 'ovp - service and repair - coverage screen - clicked benefits',
  sarCoverageScreenRepairFacilityViewed: 'ovp - service and repair - coverage screen - repair facility viewed',
  sarCoverageScreenAddressFocused: 'ovp - service and repair - coverage screen - address focused',
  sarCoverageScreenAddressChanged: 'ovp - service and repair - coverage screen - address changed',
  sarCoverageScreenRepairFacilitiesReturned: 'ovp - service and repair - coverage screen - repair facilities returned',

  openModalEvent: 'ovp - landing page - open account modal for unauthenticated user',
  clickedSignIn: 'ovp - landing page - clicked sign in',

  ovpExperiment: 'ovp - experiment',
  sevenDayMoneyBackGuaranteeExperiment: 'ovp - 7dmbg - experiment',

  sarsNoSaleEffectiveDate: 'ovp - service and repair - no sale effective date',

  // painted door experiment
  paintedDoorExperiment: 'ovp - service and repair - painted door - experiment bucket',
  paintedDoorViewed: 'ovp - service and repair - painted door - viewed',
  paintedDoorClickedNext: 'ovp - service and repair - painted door - clicked next',
  paintedDoorDismissed: 'ovp - service and repair - painted door - dismissed',

  // vehicle concern details experiments
  vehicleConcernDetailsCosmeticExperiment:
    'ovp - service and repair - vehicle concern details cosmetic - experiment bucket',
  vehicleConcernDetailsNonCosmeticExperiment:
    'ovp - service and repair - vehicle concern details non-cosmetic - experiment bucket',
  cosmeticExteriorLocationExperiment: 'ovp - service and repair - cosmetic exterior location - experiment bucket',
  vehicleConcernDetailsViewed: 'ovp - service and repair - vehicle concern details - viewed',
  vehicleConcernDetailsClickedNext: 'ovp - service and repair - vehicle concern details - clicked next',
  vehicleConcernDetailsCosmeticViewed: 'ovp - service and repair - vehicle concern details cosmetic - viewed',
  vehicleConcernDetailsCosmeticSubmitted: 'ovp - service and repair - vehicle concern details cosmetic - submitted',
  vehicleConcernDetailsTextboxFocused: 'ovp - service and repair - vehicle concern details - textbox focused',

  // my cars reskin experiment
  myCarsReskinExperiment: 'ovp - my cars reskin - experiment bucket',

  // my cars reskin axios observability (compare control vs control_fixed)
  myCarsReskinAuth401: 'my-cars-reskin-auth-401',
  myCarsReskinAuthRefresh: 'my-cars-reskin-auth-refresh',
  myCarsReskinRequestRetry: 'my-cars-reskin-request-retry',
  myCarsReskinRequestFailed: 'my-cars-reskin-request-failed',
  // fixed-only: the reference-type fallback chain resolved a load control would have 404'd on null type
  myCarsReskinReferenceTypeResolved: 'my-cars-reskin-reference-type-resolved',
  // fixed-only tripwire: normalization should make this unreachable - if it fires, normalization missed something
  myCarsReskinInvalidUrlBlocked: 'my-cars-reskin-invalid-url-blocked',

  // SAR observability events (Datadog-only)
  sarSaveUserDetailsNoResponse: 'sar-save-user-details-no-response',
  sarCoverageScreenSaveInvoked: 'sar-coverage-screen-save-invoked',
  sarFetchFacilitiesNullAsrId: 'sar-fetch-facilities-null-asr-id',
  sarFetchRepairFacilitiesProviderError: 'sar-fetch-repair-facilities-provider',
  sarFetchUserAddressProviderError: 'sar-fetch-user-address-provider',
};

export const BCID = 'BrowserCookieId';

export const SARS_HIGH_INTENT_COOKIE = 'Service-And-Repairs-High-Intent';

export const UNASSIGNED = 'unassigned';
